import React from 'react';

function Card({ className = '', children, as: Component = 'div' }) {
  return (
    <Component
      className={[
        'rounded-2xl border border-slate-200/80 bg-white/85 shadow-sm shadow-slate-900/5 backdrop-blur',
        className,
      ].join(' ')}
    >
      {children}
    </Component>
  );
}

export default Card;
